import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";
import { consoleEnableKey } from "../../../components/common/constant";

const initialState = {
  error: "",
  loading: false,
};

export const GetDataActiveDeactive = createEncryptedAsyncThunk(
  "managementSlice/GetDataActiveDeactive",
  "account/GetAppCongfigKeyDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      master_key: params.masterKey,
    }),
  }
);

export const getUserMasterData = createEncryptedAsyncThunk(
  'UserManagement/getUserMasterData',
  'Service/GetUserMasterData',
  {
    prepareBody: (params) => ({
      userId: params.userguid,
      user_id: params.user_id || '',
      key: params.key || '',
    }),
  },
);

export const getUserwiseServiceList = createEncryptedAsyncThunk(
  "managementSlice/getUserwiseServiceList",
  "Service/GetUserServiceMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      service_userId: params.selectedUser || 0,
    }),
  }
);

export const updateUserServiceRights = createEncryptedAsyncThunk(
  "managementSlice/updateUserServiceRights",
  "Service/UpdateUserServiceMaster",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceDetails: params.UpdatedServiceList,
    }),
  }
);

export const updateUserMasterData = createEncryptedAsyncThunk(
  'UserManagement/updateUserMasterData',
  'Service/UpdateUserMasterData',
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      updateAll: params.updateAll || false,
      updateMasterkey: params.updateMasterkey || '',
      keyDatas: params.keyDatas || [],
    }),
  },
);

export const getIPLockDetails = createEncryptedAsyncThunk(
  "managementSlice/GetIPLockDetails",
  "account/GetIPLockDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      username: params.username || '',
      ipAddress: params.ipaddress || '',
      role: params.role || 0
    }),
  }
);

export const deleteIpLockList = createEncryptedAsyncThunk(
  "managementSlice/deleteIpLockList",
  "Service/DeleteIpLock",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ipLockId: params.ipLockId || 0,
    }),
  }
);

export const getSchedulerDetails = createEncryptedAsyncThunk(
  "adminReportSlice/getSchedulerDetails",
  "Service/GetSchedulerDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      schdeulerName: params.schdeulerName || "",
    }),
  }
);

export const updateAppConfigKeyDetails = createEncryptedAsyncThunk(
  "Commission/updateAppConfigKeyDetails",
  "account/UpdateAppConfigKeyDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      master_key: params.master_key || "",
      status: params.status || false,
      value: params.value,
      value1: params.value1 || "",
      remark: params.remark || "",
    }),
  }
);

export const updateSchedulerStatus = createEncryptedAsyncThunk(
  "adminReportSlice/updateSchedulerStatus",
  "Service/UpdateSchedulerStatus",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      schdeulerName: params.schdeulerName || "",
      status: params.status || "0",
      runningStatus: params.runningStatus || "0",
    }),
  }
);

export const GetMasterDataDetails = createEncryptedAsyncThunk(
  "managementSlice/GetMasterDataDetails",
  "account/Get_Master_Data_Details",
  {
    prepareBody: (params) => ({
      userID:  params.currentUser.userGuid,
      key1: params.masterKey || '',
      value: params.value || "",

    }),
  }
);

export const updateMasterDataDetails = createEncryptedAsyncThunk(
  "managementSlice/updateMasterDataDetails",
  "account/Update_Master_Data_Details",
  {
    prepareBody: (params) => ({
      userID:  params.currentUser.userGuid,
      key1: params.key1 || "",
      value: params.value || "",
      status: params.status || 0,
      remark: params.remark || "",
      value1: params.value1 || "",
      value2: params.value2 || "",
      value3: params.value3 || "",
      created_date: params.created_date || "",

    }),
  }
);

export const getLoginHistory = createEncryptedAsyncThunk(
  "managementSlice/getLoginHistory",
  "account/GetUserLoginLogs",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      userLogId: params.userLogId || 0,
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
      ipAddress: params.ipAddress || "",
    }),
  }
);

export const querryRemitterAction = createEncryptedAsyncThunk(
  "managementSlice/querryRemitterAction",
  "transaction/QuerryRemitter",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      serviceId: params.serviceId || 0,
      mobile: params.mobile || "",
      latitude: `${params.latitude}` || "",
      longitude: `${params.longitude}` || "",
      updateLimit: params.updateLimit || false,
      otpToken: params.otpToken || "",
      otp: params.otp || "",
    }),
  }
);

export const updateCustomerDataActiona = createEncryptedAsyncThunk(
  "managementSlice/updateCustomerDataActiona",
  "account/UpdateCustomerData",
  {
    transUrl: process.env.REACT_APP_API_TRANSACTION,
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      custId: params.custId || 0,
      custName: params.custName,
      status: params.status || 0,
      resetLimit: params.resetLimit ||false,
      resetAmt: _.toNumber(params.resetAmt) || 0,
    }),
  }
);

export const updateCustomerLimitAction = createEncryptedAsyncThunk(
  "managementSlice/updateCustomerLimitAction",
  "account/UpdateCustomerLimit",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      customer_mobile: params.customer_mobile || '',
      updateAll: params.updateAll || false,
      serviceId: params.serviceId || 0,
      limit: params.limit || 0,
    }),
  }
);

export const getNotificationDetailsAction = createEncryptedAsyncThunk(
  "managementSlice/getNotificationDetailsAction",
  "account/GetNotificationDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      roles: params.roles || [],
      serviceId: params.serviceId || [],
      city: params.city || [],
      states: params.states || '',
      platform: params.platform || [],
      status: params.status || [],
      startDate: params.startDate || null,
      endDate: params.endDate || null,
      notification_type: params.notification_type || '',
    }),
  }
);

export const createNotificationAction = createEncryptedAsyncThunk(
  "managementSlice/createNotificationAction",
  "account/CreateNotification",
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      language: params.language || [],
      platform: params.platform || [],
      role: params.role || [],
      services: params.services || [],
      state: params.state || [],
      city: params.city || [],
      start_Date: params.start_Date || null,
      end_Date: params.end_Date || null,
      images: params.images || [],
      description: params.description || '',
      notification_type: params.notification_type || ''
    }),
  }
);

export const updateNotificationsAction = createEncryptedAsyncThunk(
  "managementSlice/UpdateNotifications",
  "account/UpdateNotifications",
  {
    prepareBody: (params) => ({
      userId: params.currentUser.userGuid,
      language: params.language || [],
      platform: params.platform || [],
      role: params.role || [],
      services: params.services || [],
      state: params.state || [],
      city: params.city || [],
      start_Date: params.start_Date || null,
      end_Date: params.end_Date || null,
      images: params.images || [],
      description: params.description || '',
      notification_type: params.notification_type || '',
      notificationID: params.notificationID || 0,
      status: params.status || 0
    }),
  }
);

export const getUserRoleRightStatusAction = createEncryptedAsyncThunk(
  "managementSlice/getUserRoleRightStatusAction",
  "Roles/GetUserRoleRightStatus",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      requestUserid: params.requestUserid || 0,
      roleId: params.roleId || 0
    }),
  }
);

export const updateUserRoleRightStatusAction = createEncryptedAsyncThunk(
  "managementSlice/updateUserRoleRightStatusAction",
  "account/UpdateUserRoleRightStatus",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      role_rights: params.role_rights || []
    }),
  }
);

export const managementSlice = createSlice({
  name: "managementSlice",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(GetDataActiveDeactive.fulfilled, (state, action) => {
        state.status = 'details';
        if (!_.isEmpty(action.meta) && !_.isEmpty(action.meta.arg) && action.meta.arg.masterKey === consoleEnableKey) {
          let consoleEnable = null
          if (action.payload && !_.isEmpty(action.payload.data)) {
            if (_.trim(action.payload.data.master_key) === consoleEnableKey) {
              consoleEnable = action.payload.data
            }
          }
          state.consoleEnable = consoleEnable
        }
      })
  },
  reducers: {},
});

export default managementSlice.reducer;